import styled from 'styled-components';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { SearchResultKb } from 'view/common/result-kb';

export const Root = styled.div`
    width: 100%;
`;

export const Container = styled.div<{ isSmartSnippetsEnabled?: boolean }>`
    padding: ${token('space.200', '16px')};
    background-color: ${token('color.background.neutral', colors.N10)};
`;

export const KbArticle = styled(SearchResultKb)`
    transition: box-shadow 0.2s ease-in-out;
`;
